const Component = () => import('./Notifications');

export { Component };
